import cloneDeep from 'lodash/cloneDeep'
import { mediaIri } from './AddressImage'

class UserAddressesFormMapper {
    toEntity(values) {
        const entity = cloneDeep(values)

        for (const [key, value] of Object.entries(entity)) {
            if (value === '') {
                entity[key] = null
            }
        }

        // the address photo is written as its media IRI (tasks#227), like a brand's cover
        if ('image' in entity) entity.image = mediaIri(entity.image)

        return entity
    }

    fromEntity(entity) {
        return cloneDeep(entity)
    }
}

export default new UserAddressesFormMapper()
